export default class {
    init() {
        this.mobileScroll = 0;
        this.mobileMenuToggle = document.getElementById('open_mobile');
        this.mobileMenuToggle.addEventListener('click', () => this.toggleMenu());
        this.nav = document.querySelector('nav#mobile');
    }

    /**
     * Toggles the visibility of the main menu
     */
    toggleMenu() {
        if (this.mobileMenuToggle.classList.contains('is-active')) {

            if (this.mobileScroll) {
                window.scrollTo(0, this.mobileScroll);
            }
            document.body.style.overflow = 'visible';
            this.mobileMenuToggle.className =
                this.mobileMenuToggle.className.replace('is-active', '');
            this.nav.className = this.nav.className.replace('visible', '');
        } else {
            this.mobileScroll = window.scrollY;
            window.scrollTo(0, 0);
            document.body.style.overflow = 'hidden';
            this.mobileMenuToggle.className+= ' is-active';
            this.nav.className+= ' visible';
        }
    }
    finalize() {
    }
};



// WEBPACK FOOTER //
// ./app/resources/js/routes/common.js